<app-modal-header (closeModal)="close()"> </app-modal-header>
@defer (when reason !== null) {
  <app-modal-body>
    <h1 class="fs-5" [innerHTML]="'HOLD_ON' | translate"></h1>
    <p class="mb-0">
      {{
        'YOU_PREVIOUSLY_DECLINED_THIS_REQUEST_BECAUSE_SOMEREASON_WOULD_YOU_LIKE_TO_UNDO_YOUR_DECLINE'
          | translate: { reason }
      }}
    </p>
  </app-modal-body>
  <app-modal-footer classList="d-flex justify-content-center">
    <button
      type="button"
      class="btn btn-primary rounded-5 fw-medium"
      (click)="undeclineReq()"
      [disabled]="isHttpRequestRunning && activeButton === ActiveButton.UNDECLINE_MEETING"
    >
      @if (isHttpRequestRunning && activeButton === ActiveButton.UNDECLINE_MEETING) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ 'YES' | translate }}
    </button>
    @if (!isExternalMode) {
      <button
        type="button"
        class="btn rounded-5 fw-medium"
        (click)="close()"
        [class.btn-outline-dark]="!isBgDarkMode"
        [class.btn-outline-light]="isBgDarkMode"
      >
        {{ 'NO_GO_BACK' | translate }}
      </button>
    }
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <app-skeleton-general-list [count]="4" />
    </app-modal-body>
  }
}
